import { AvatarComponent } from '@/components/avatar/avatar';
import { Button } from '@/components/ui/button';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { useDataAnalytics } from '@/hooks/analytics/analytics';
import { useAuth } from '@/hooks/use-auth';
import React from 'react';

const buttonTextClass = '!text-sm text-primary font-semibold';

export const SignInCreateAccount = (): React.JSX.Element => {
  const { signIn, signUp } = useAuth();
  const { trackClick } = useDataAnalytics();

  const signInWithTracking = (): void => {
    trackClick({
      linkCategory: AnalyticsPageCategories.MAIN_NAV,
      linkName: 'Login',
    });

    signIn();
  };

  const signUpWithTracking = (): void => {
    trackClick({
      linkCategory: AnalyticsPageCategories.MAIN_NAV,
      linkName: 'Register',
    });

    signUp();
  };

  return (
    <div className="flex items-center gap-xs">
      <AvatarComponent className="hidden md:block"
        type="header"
      />
      <Button className={buttonTextClass}
        data-test="button-login"
        variant="link"
        onClick={signInWithTracking}
      >
        Sign In
      </Button>
      <span className="text-sm lg:text-md">or</span>
      <Button className={buttonTextClass}
        data-test="button-register"
        variant="link"
        onClick={signUpWithTracking}
      >
        Create an Account
      </Button>
    </div>
  );
};
